export default [
  { value: 'SFD', label: 'SFD' },
  { value: 'SFA/Townhouse', label: 'SFA/Townhouse' },
  { value: 'Condo', label: 'Condo' },
  { value: 'Multi unit', label: 'Multi unit' },
  { value: 'Mobile', label: 'Mobile' },
  { value: 'Home/Modular', label: 'Home/Modular' },
  { value: 'Vacant land', label: 'Vacant land' },
];
